import { render, staticRenderFns } from "./StyleBadgeList.vue?vue&type=template&id=e89cec22&scoped=true&"
import script from "./StyleBadgeList.vue?vue&type=script&lang=js&"
export * from "./StyleBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./StyleBadgeList.vue?vue&type=style&index=0&id=e89cec22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89cec22",
  null
  
)

export default component.exports